import { render, staticRenderFns } from "./SavedQuestions.vue?vue&type=template&id=6d6f1e91&"
import script from "./SavedQuestions.vue?vue&type=script&lang=js&"
export * from "./SavedQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d6f1e91')) {
      api.createRecord('6d6f1e91', component.options)
    } else {
      api.reload('6d6f1e91', component.options)
    }
    module.hot.accept("./SavedQuestions.vue?vue&type=template&id=6d6f1e91&", function () {
      api.rerender('6d6f1e91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/Security/SecurityQuestions/SavedQuestions.vue"
export default component.exports